import { DynamicStandaloneIcon, DynamicStandaloneIconProps } from '@/components/Icon';
import { propClassName } from '@/styles/TextField';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface TextFieldIconProps extends ComponentProps<'svg'> {
  name?: DynamicStandaloneIconProps['name'];
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

export const TextFieldIconComponent: Component<TextFieldIconProps> = ({
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const sizeClassName = propClassName('icon_size', size ?? variant, 'default');
  const colorsClassName = propClassName('icon_colors', colors, 'primary');
  const variantClassName = propClassName('icon_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return <DynamicStandaloneIcon options={{ className: componentClassName, size: 'none' }} {...props} />;
};
